import React from 'react';

import Hero from './components/Hero';
import ContactIntro from './components/ContactIntro';


export default class extends React.Component {

  render() {
    document.title = "Berichten - Peter van der Meer - Ik maak LinkedIn gemakkelijk. - Ghostin.nl";
    return (
      <div>

        <Hero
          h1split1="Bouw een naam "
          h1split2="die blijft hangen."
          h2 = "Ik schrijf strategische LinkedIn-berichten die jouw profiel zichtbaar maakt bij de juiste mensen, en jouw autoriteit versterken."
        />

        <div className="full big black">
          <div className="wrap content-block">
            <h2 style={{marginBottom:".3em"}}>Pakketten</h2>
            <div className="col-2" style={{margin:"0 auto", display:"block"}}>
              <h3 style={{marginTop:"0"}}>Iedere samenwerking is direct weer opzegbaar, maar zonder terugbetaling. Betaling gaat vooraf iedere periode, werkzaamheden worden gepland zodra de betaling ontvangen is.<br/><br/>Er is ook een bonus beschikbaar van 1 LinkedIn Artikel per 4 weken, als je 6x vier weken afneemt.<br/><br/>De 6x vier weken periode wordt volledig van tevoren gefactureerd. Hierbij ben je wel beschermd tegen mogelijke prijsverhogingen.</h3>
            </div>

            <div className="col-2" style={{marginTop:"2em"}}>
              <div style={{background:"#116CB2", color:"#fff", textAlign:"center", padding:".2em", borderRadius:"5px", boxShadow:"3px 3px black"}}>WHITE GLOVE</div>
              <div className="card more-rounded"style={{background:"#116CB2", color:"#fff"}}>
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Autoriteitsregie</h3>
                <p style={{marginBottom:"1em"}}>Voor leiders die hun zichtbaarheid niet zelf willen beheren, maar hun marktpositie willen laten sturen.</p>
                <p style={{fontWeight:"bold"}}>Iedere vier weken:</p>
                <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontWeight:"bold", fontSize:"1.3em"}}>
                  <li>2x Thought Leader Extractie Interview <b style={{fontWeight:"normal"}}>(30 min.)</b></li>
                  <li>Volledige Content-aansturing en uitwerking <b style={{fontWeight:"normal"}}>(frequentie op maat)</b></li>
                  <li>Strategische Autoriteitssturing <b style={{fontWeight:"normal"}}>(doorlopend)</b></li>
                  <li>Ontwikkeling Signature Frameworks & Ideeën <b style={{fontWeight:"normal"}}>(Intellectueel Eigendom)</b></li>
                  <li>Persoonlijk Merk Ecosysteem Begeleiding <b style={{fontWeight:"normal"}}>(podcasts, events, etc)</b></li>
                  <li>Reputatie & Publieke Positioneringsbewaking <b style={{fontWeight:"normal"}}>(richtlijnen)</b></li>
                  <li>1x Autoriteitstraject Rapportage</li>
                  <li>Hoogste Prioriteit Toegang & Ondersteuning</li>
                </ul>
                <div style={{fontSize:"1.2em"}}>
                  <p style={{marginTop:"1em"}}>Voor wie zijn reputatie niet zelf wil beheren, maar strategisch wil laten regisseren.</p>
                  <p style={{marginTop:"1em",fontSize:"85%"}}><span style={{color:"#F2AA22"}}>19625</span> per vier weken</p>
                </div>
              </div>
            </div>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div style={{background:"#E5C88D", color:"#000", textAlign:"center", padding:".2em", borderRadius:"5px", boxShadow:"3px 3px black"}}>POPULAIR</div>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Autoriteit Bouwer</h3>
                <p style={{marginBottom:"1em"}}>Als kern zijn dit gerichte berichten die sturen hoe jij gezien wordt. Voor professionals die hun berichten willen laten kloppen met hun expertise en hun niveau. Geen opvulling, maar doelgerichte en strategische posts die bijdragen aan autoriteit, herkenbaarheid, en uitstraling.</p>
                <p style={{fontWeight:"bold"}}>Iedere vier weken:</p>
                <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontWeight:"bold", fontSize:"1.3em"}}>
                  <li>2x Thought Leader Extractie Interview <b style={{fontWeight:"normal"}}>(30 min.)</b></li>
                  <li>Wekelijks strategische berichten</li>
                  <li>Contact via LinkedIn, e-mail, en 06</li>
                  <li>1x strategie en analyse videobelafspraak</li>
                  <li>1x per 12 weken profiel en positionering optimalisatie</li>
                </ul>
                <div style={{fontSize:"1.2em"}}>
                  <p style={{marginTop:"1em"}}>Perfect voor wie actief wil bouwen aan autoriteit, maar de regie nog niet volledig wil uitbesteden.</p>
                  <p style={{marginTop:"1em",fontSize:"85%"}}><span style={{color:"#8bc34a"}}>3850</span> per vier weken</p>
                </div>
              </div>
            </div>
            <small style={{marginBottom:".3em", marginTop:"1em", opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>prijzen zijn exclusief 21% BTW.</small>

          </div>
        </div>

        <ContactIntro />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/ServicesPosts.js